
    import '/opt/buildhome/repo/packages/x/components/prompts/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["prompts-demo-basic","prompts-demo-disabled","prompts-demo-flex-vertical","prompts-demo-flex-wrap","prompts-demo-flex-wrap-fixed","prompts-demo-nest","prompts-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/prompts/index.en-US.md?type=demo')
};